import React, { Suspense, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // ✅ Add this

// Preloader
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));

// Pages
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
const Roomgrid = React.lazy(() => import("./components/pages/Roomgrid"));
const Roomlist = React.lazy(() => import("./components/pages/Roomlist"));
const Roomdetails = React.lazy(() => import("./components/pages/Roomdetails"));
const Blog = React.lazy(() => import("./components/pages/Blog"));
const Blogstandard = React.lazy(() => import("./components/pages/Blogstandard"));
const Blogdetails = React.lazy(() => import("./components/pages/Blogdetails"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const About = React.lazy(() => import("./components/pages/About"));
const Gallery = React.lazy(() => import("./components/pages/Gallery"));
const Restaurant = React.lazy(() => import("./components/pages/Restaurant"));
const Places = React.lazy(() => import("./components/pages/Places"));
const Placesdetails = React.lazy(() => import("./components/pages/Placesdetails"));
const Offers = React.lazy(() => import("./components/pages/Offers"));
const Menu = React.lazy(() => import("./components/pages/Menu"));

function ScrollToTop({ children }) {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return children;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <ScrollToTop>
            <Preloader />
            <Routes>
              <Route path="/" element={<Hometwo />} />
              <Route path="/room-grid" element={<Roomgrid />} />
              <Route path="/room-list" element={<Roomlist />} />
              <Route path="/room-details/:id" element={<Roomdetails />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/cat/:catId" element={<Blog key="cat" />} />
              <Route path="/blog/tag/:tagId" element={<Blog key="tag" />} />
              <Route path="/blog/user/:userId" element={<Blog key="user" />} />
              <Route path="/blog-standard" element={<Blogstandard />} />
              <Route path="/blog-details/:id" element={<Blogdetails />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/restaurant" element={<Restaurant />} />
              <Route path="/places" element={<Places />} />
              <Route path="/places-details/:id" element={<Placesdetails />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/menu" element={<Menu />} />
            </Routes>
          </ScrollToTop>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;
